import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import React, { useState } from 'react'
import { MDBCollapse, MDBBtn, MDBRow, MDBCol, MDBIcon, MDBCard, MDBCardHeader, MDBCardBody } from 'mdb-react-ui-kit'
import CarrierMgmtStore from './../../CarrierMgmt.store'
import CarrierLinkBankStore from './../../CarrierLinkBank.store'

import './CarrierContractLinkBank.scss'

const ucwords = str => str.replace(/^([a-z])|[\s_]+([a-z])/g, $1 => $1.toUpperCase())

const CARRIER_COMM_CODES = ['USABG505', 'USABG405', 'USABG305', 'USABG205', 'USABG30', 'USABG20', 'USABG10', 'USABGLOA']

const CarrierContractLinkBank = ({ table }) => {
  const [load, setLoad] = useState(false)

  const onSubmit = async event => {
    event.preventDefault()
    await CarrierLinkBankStore.saveLeaderCommLinks()
  }

  const onClose = () => {
    CarrierLinkBankStore.leaderId = null
    CarrierLinkBankStore.user = {}
    CarrierLinkBankStore.userContractLinks = {}
    CarrierLinkBankStore.Leader = null
  }

  const viewLeader = leaderId => {
    leaderId = isNaN(leaderId) ? null : parseInt(leaderId)
    CarrierLinkBankStore.leaderId = leaderId
    CarrierLinkBankStore.Leader = toJS(CarrierLinkBankStore.Leaders)
      .filter(Leader => parseInt(Leader.id()) === parseInt(leaderId))
      .shift()
    if (leaderId) CarrierLinkBankStore.fetchLeaderCommLinks()
  }

  const renderLockOut = () => {
    if (!CarrierMgmtStore.carrier || (CarrierMgmtStore.carrier && isNaN(CarrierMgmtStore.carrier?.id)))
      return <div className='lockout-window'>lockout</div>
    if (load === false) setLoad(true)
  }

  const renderCommLinkInput = comCode => {
    const modes = {
      link: 'link',
      acr: 'document_id',
      pdf: 'document_id',
    }

    let commLevel = CarrierMgmtStore.commLevels[comCode],
      UserContractLink = CarrierLinkBankStore.userContractLinks[comCode],
      mode = UserContractLink?.getMode() || ''

    const getValue = () => UserContractLink?.getModeValue() || ''

    const setValue = value => {
      if (mode && modes[mode] && UserContractLink) UserContractLink.set(modes[mode], value)
    }

    if (commLevel && UserContractLink) {
      return (
        <MDBRow key={`carr-comm-code-row-${comCode}`}>
          <MDBCol className='contract-link-setter'>
            <label>
              <strong>{commLevel.com_name}</strong>
              {UserContractLink.hasChanged ? (
                UserContractLink.isValid() ? (
                  <MDBIcon far icon='check-circle' className='green-text pl-2' />
                ) : (
                  <MDBIcon far icon='times-circle' className='red-text pl-2' />
                )
              ) : (
                <></>
              )}
              &nbsp;<small style={{ color: '#999' }}>({comCode})</small>
            </label>
            <div className='input-group mb-3 mt-0 contract-link-input-group'>
              <input
                type='text'
                className='form-control form-control-sm'
                value={getValue()}
                onChange={evt => setValue(evt.target.value || '')}
                placeholder={mode === 'LINK' ? 'URL' : 'Document ID'}
                aria-label={commLevel.com_name}
              />
              <div className='input-group-append'>
                <select
                  className='form-control form-control-sm custom-select mode-select'
                  value={UserContractLink?.get('mode') || 'LINK'}
                  onChange={e => UserContractLink.set('mode', e.target.value)}
                  aria-label='Mode'
                >
                  <option value='LINK'>Link</option>
                  <option value='PDF'>Adobe PDF</option>
                  <option value='ACR'>Adobe ACR</option>
                </select>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      )
    }
  }

  const renderInputs = () => CARRIER_COMM_CODES.map(renderCommLinkInput)

  const renderForm = () => {
    return (
      <MDBCollapse open={!!CarrierLinkBankStore.leaderId}>
        <form noValidate onSubmit={onSubmit}>
          {!CarrierLinkBankStore.loading['fetch.user'] ? renderInputs() : <></>}
          <MDBRow>
            <MDBCol size='12' md='8'>
              <MDBBtn
                color='default'
                className='btn-block btn-submit'
                type='submit'
                disabled={!CarrierLinkBankStore.hasChanged}
              >
                {CarrierLinkBankStore.loading['update.comm-links'] ? (
                  <span>
                    Saving Links...&nbsp;
                    <i className='fa fa-spin fa-spinner' />
                  </span>
                ) : (
                  <>
                    Save Carrier-Agent Commission Links&nbsp;
                    <MDBIcon icon='save' />
                  </>
                )}
              </MDBBtn>
            </MDBCol>
            <MDBCol size='12' md='4'>
              <MDBBtn color='default' block className='btn-cancel' onClick={onClose} type='button'>
                Done&nbsp;
                <MDBIcon icon='times' />
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </form>
      </MDBCollapse>
    )
  }

  return (
    <MDBCard id='CarrierContractLinkBankComponent'>
      {renderLockOut()}
      <MDBCardHeader>Carrier Contract Link Bank</MDBCardHeader>
      <MDBCardBody>
        <div className='form-group contract-link-leader-select'>
          <label className='form-label'>Choose Leader to access their Link Bank</label>
          <select
            className='form-control'
            value={CarrierLinkBankStore.leaderId || ''}
            onChange={e => {
              const id = e.target.value ? e.target.value : null
              if (id != null && `${id}` !== `${CarrierLinkBankStore.leaderId}`) viewLeader(id)
            }}
            disabled={!!(CarrierLinkBankStore.leaderId > 0)}
            aria-label='Choose Leader'
          >
            <option value=''>Choose Leader</option>
            {(CarrierLinkBankStore.Leaders || []).map((Leader, idx) => {
              const id = typeof Leader.id === 'function' ? Leader.id() : Leader.id
              const fname = Leader.get ? Leader.get('u_fname') : Leader.u_fname || ''
              const lname = Leader.get ? Leader.get('u_lname') : Leader.u_lname || ''
              return (
                <option key={id != null ? id : idx} value={id != null ? id : ''}>
                  {ucwords(`${fname} ${lname}`)}
                </option>
              )
            })}
          </select>
        </div>
        {renderForm()}
      </MDBCardBody>
    </MDBCard>
  )
}

export default observer(CarrierContractLinkBank)
